import InstagramIcon from '@mui/icons-material/Instagram';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Typography, Box, Grid, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { LICENSES } from '../core/router/paths';
import PatreonIcon from '../images/patreon.svg';


const Footer: React.FC = () =>
{

  return (
    <Box component='footer' sx={{ mt: 'auto', pt: '50px' }}>
      <hr/>
      <Grid container direction='row' >

        <Grid item xs style={{ display: "flex", justifyContent: "flex-start" }}>
          <Link
            variant='body2'
            color='text.secondary'
            component={RouterLink}
            to={LICENSES}>
            {"Licenses"}
          </Link>
        </Grid>

        <Grid item xs style={{ display: "flex", justifyContent: "center" }}>
          <Link
            variant='body2'
            target='_blank'
            rel='noreferrer'
            href={"https://www.instagram.com/protoplan.me/"} >
            <InstagramIcon htmlColor='gray'/>
          </Link>
            <Box sx={{ width: 0.02 }}/>
          <Link
            variant='body2'
            target='_blank'
            rel='noreferrer'
            href={"https://www.patreon.com/Protoplan/"} >
            <Box sx={{ pt: '2px' }}>
              <PatreonIcon/>
            </Box>
          </Link>
          <Box sx={{ width: 0.02 }}/>
          <Link
            variant='body2'
            target='_blank'
            rel='noreferrer'
            href={"mailto:protoplan.me@protonmail.com"} >
            <EmailOutlinedIcon htmlColor='gray'/>
          </Link>
        </Grid>

        <Grid item xs style={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography variant='body2' color='text.secondary'>
            {'Copyright © '}
            <Link color='inherit' href='https://protoplan.me'>
              Protoplan Ltd
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
          </Typography>
        </Grid>

      </Grid>
    </Box>);
};

export default Footer;


